export default __webpack_public_path__ + "static/media/unlimitedUsersIcon.a70daf8c.svg";